import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import PhproductshapeFilterCriteria from './PhproductshapeFilterCriteria'
import PhproductshapeList from './PhproductshapeList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './PhproductshapeAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setPhproductshapeDashboardPhproductshapeList } from '../../store/slice/PharmaSlice';

export default function PhproductshapeListView({setShowEdit,setPhproductshapeId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.phproductshapeDashboard);   

    const [filteredPhproductshapeList, setFilteredPhproductshapeList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { phproductshapeDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (phproductshapeDashboard.phproductshapeList.length>-1){
        setFilteredPhproductshapeList(phproductshapeDashboard.phproductshapeList);
        transformToCardFormat(phproductshapeDashboard.phproductshapeList, setCardList);
      }
    },[phproductshapeDashboard.phproductshapeList])

    useEffect(()=>{
          transformToCardFormat(filteredPhproductshapeList, setCardList);
      },[filteredPhproductshapeList])

    useEffect(()=>{
        if (filterCriteria.title==='' && filterCriteria.formid==='' && filterCriteria.formname==='' ){
            setFilteredPhproductshapeList(phproductshapeDashboard.phproductshapeList);
            transformToCardFormat(phproductshapeDashboard.phproductshapeList, setCardList);

        } else {
            setFilteredPhproductshapeList(
                phproductshapeDashboard.phproductshapeList
                    .filter(phproductshape=> phproductshape.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))
.filter(phproductshape=> phproductshape.formid.toString().toUpperCase().includes(filterCriteria.formid.toString().toUpperCase()))
.filter(phproductshape=> phproductshape.formname.toString().toUpperCase().includes(filterCriteria.formname.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(phproductshapeDashboard.filteredPhproductshapeList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <PhproductshapeList
                    setShowEdit={setShowEdit}
                    setPhproductshapeId = {setPhproductshapeId}
                    tableList={filteredPhproductshapeList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}